import { AppStates } from "utils/helpers/app.helpers"
import withProtectedRoute from "utils/hocs/withProtectedRoute"
import CreditBuilderDescriptionContainer from "../../containers/CreditBuilder/CreditBuilderContainer/CreditBuilderContainer"

const CreditBuilderScreen = () => {
  return <CreditBuilderDescriptionContainer />
}

export default withProtectedRoute(CreditBuilderScreen, AppStates.homeState)
